export default {
  modalTitle: {
    id: 'product_page_modal_shipping_title',
    defaultMessage: 'Shipping information',
  },
  businessDayTitle: {
    id: 'product_page_modal_shipping_business_day_title',
    defaultMessage: 'We mean business days',
  },
  businessDayLabel: {
    id: 'product_page_modal_shipping_business_day_label',
    defaultMessage:
      'This means we don’t count weekends and holidays in delivery times.',
  },
  shoppingTimingTitle: {
    id: 'product_page_modal_shipping_shopping_timing_title',
    defaultMessage: 'A note for PM shoppers',
  },
  shoppingTimingLabel: {
    id: 'product_page_modal_shipping_shopping_timing_label',
    defaultMessage:
      "If you order after 1:00 pm the delivery time is calculated from 8:00 am the next day. Bear that in mind if you're doing some late-night shopping!",
  },
  trackDeliveryTitle: {
    id: 'product_page_modal_shipping_track_delivery_title',
    defaultMessage: 'Track your delivery in real time',
  },
  trackDeliveryLabel: {
    id: 'product_page_modal_shipping_track_delivery_label',
    defaultMessage:
      'After making your purchase, you should receive your tracking number within 24 hours (by email and on your account) so you can keep tabs on where it is.',
  },
}
